module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-120x120-a69d686f7aea92f4d31fd89cbb200e41.png";